import Resizer from 'react-image-file-resizer';

const shouldBeResized = (file, maxSize) => {
    const isImage = file.type.split('/')[0] === 'image'
    const isSizeExtrapolated = file.size > maxSize
    return isImage && isSizeExtrapolated
}

const resizeFile = async (file) => {
    const maxFileSize = 100 * 1000
    console.log(file, shouldBeResized(file, maxFileSize))
    if (!shouldBeResized(file, maxFileSize)) return file;

    let finalSize = file.size;
    let maxWidth = 1024
    let maxHeight = 768
    const minWidth = 50
    const minHeight = 37.5
    const quality = 95
    const rotation = 0
    const outputFormat = 'file'
    const compressFormat = file.type.split('/')[1].toUpperCase()

    let newFile
    const resizeStep = 50

    while (finalSize > maxFileSize) {
        newFile = await new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                maxWidth,
                maxHeight,
                compressFormat,
                quality,
                rotation,
                (uri) => {
                    resolve(uri);
                },
                outputFormat,
                minWidth,
                minHeight
            );
        });

        finalSize = newFile.size;
        maxWidth = maxWidth - resizeStep;
        maxHeight = maxHeight - resizeStep;
    };

    return newFile;
};

export default resizeFile;
